import React from 'react';
import ChatbotUIOnboarding from './onboarding/ChatbotUIOnboarding';

const OnboardingWizard: React.FC = () => {
  return <ChatbotUIOnboarding />;
};

export default OnboardingWizard; 